import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';

const InfoText = ({ data }) => {
  const { title, className } = data;
  const isDataArray = isArray(data);

  return isDataArray ? (
    data.map(item => (
      <p className={item.className} key={item.id}>
        {item.title}
      </p>
    ))
  ) : (
    <p className={className}>{title}</p>
  );
};

InfoText.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      className: PropTypes.string
    })
  )
};
export default InfoText;
